import React, { useState, useEffect } from 'react';
import { CalendarClock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { toast } from 'sonner';

const DateChangeModal = ({ open, onClose, onSave, currentDate, currentTime, title }) => {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setDate(currentDate || '');
      setTime(currentTime || '');
    }
  }, [open, currentDate, currentTime]);

  const today = new Date().toISOString().split('T')[0];

  const handleSave = async () => {
    if (!date) { toast.error('Tarih seçiniz'); return; }
    if (date < today) { toast.error('Geçmiş tarihe değiştirilemez'); return; }
    setSaving(true);
    await onSave(date, time || null);
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent data-testid="date-change-modal" className="sm:rounded-2xl sm:max-w-md lg:max-w-3xl sm:max-h-[75vh] overflow-hidden flex flex-col p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CalendarClock size={18} className="text-orange-500" />
            {title || 'Tarih Değiştir'}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-2">
          <div>
            <Label className="text-xs font-medium text-gray-700">Yeni Tarih *</Label>
            <Input type="date" value={date} onChange={e => setDate(e.target.value)} min={today}
              className="h-11 text-sm bg-[#F2F2F7] border-0 rounded-xl mt-1" data-testid="new-date-input" />
          </div>
          <div>
            <Label className="text-xs font-medium text-gray-700">Saat (Opsiyonel)</Label>
            <Input type="time" value={time} onChange={e => setTime(e.target.value)}
              className="h-11 text-sm bg-[#F2F2F7] border-0 rounded-xl mt-1" data-testid="new-time-input" />
          </div>
          <Button onClick={handleSave} disabled={saving}
            className="w-full h-11 bg-orange-500 hover:bg-orange-600 rounded-xl text-sm font-semibold"
            data-testid="save-date-btn">
            {saving ? 'Kaydediliyor...' : 'Tarihi Güncelle'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DateChangeModal;
